export default "__VITE_ASSET__CVpfh7rT__"